document.addEventListener('DOMContentLoaded', () => {
  const track = document.querySelector('.carousel__track');
  if (!track) return;

  const flkty = Flickity.data(track);
  const btnLeft = document.querySelector('.carousel-arrow.left');
  const btnRight = document.querySelector('.carousel-arrow.right');
  if (!flkty || !btnLeft || !btnRight) return;

  const updateArrows = () => {
    btnLeft.classList.toggle('hidden', flkty.selectedIndex === 0);
    btnRight.classList.toggle('hidden', flkty.selectedIndex === flkty.slides.length - flkty.visibleSlidesCount);
  };

  Object.defineProperty(flkty, 'visibleSlidesCount', {
    get: function() {
      const viewportWidth = flkty.viewport.clientWidth;
      let count = 0;
      let totalWidth = 0;
      flkty.slides.forEach(slide => {
        totalWidth += slide.outerWidth;
        if (totalWidth <= viewportWidth) count++;
      });
      return count || 1;
    }
  });

  // Adjust each slide by extra -2% (right and left)
  btnLeft.addEventListener('click', () => {
    const targetIndex = Math.max(flkty.selectedIndex - flkty.visibleSlidesCount, 0);
    flkty.select(targetIndex);
  
    const slides = track.querySelectorAll('.carousel__slide');
    slides.forEach(slide => {
      slide.style.transform = `translateX(calc(${slide.style.transform.replace(/translateX\((.*)\)/, '$1') || '0px'} - 2%))`;
    });
  });
  
  btnRight.addEventListener('click', () => {
    const targetIndex = Math.min(flkty.selectedIndex + flkty.visibleSlidesCount, flkty.slides.length - 1);
    flkty.select(targetIndex);

    const slides = track.querySelectorAll('.carousel__slide');
    slides.forEach(slide => {
      slide.style.transform = `translateX(calc(${slide.style.transform.replace(/translateX\((.*)\)/, '$1') || '0px'} + 2%))`;
    });
  });

  flkty.on('select', updateArrows);
  updateArrows();
});